import { isPlatformBrowser } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { APP_ID, Inject, NgModule, PLATFORM_ID } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { TransferHttpCacheModule } from '@nguniversal/common';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from '../environments/environment';
import { NgSwCheckForUpdateService } from '../shared/services/service-worker/ngsw-check-for-update.service';
import { NgSwLogUpdateService } from '../shared/services/service-worker/ngsw-log-update.service';
import { NgSwPromptUpdateService } from '../shared/services/service-worker/ngsw-prompt-update.service';
import { BrowserStorage } from '../shared/storages/browser.storage';
import { STORAGE } from '../shared/storages/storages.inject';
import { TranslateBrowserModule } from '../shared/translate/translate-browser.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './components/app.component';
import { ChooseClothesComponent } from './modules/customize/choose-clothes/choose-clothes.component';
import { StepperComponent } from './modules/stepper/stepper.component';
import { PreorderComponent } from './modules/customize/preorder/preorder.component';
import { FooterComponent } from './modules/footer/footer.component';
import { ContactInfoComponent } from './modules/contact-info/contact-info.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SuccessComponent } from './modules/success/success.component';
import { FailureComponent } from './modules/failure/failure.component';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { LOCALE_ID } from '@angular/core';
import { AngularFireModule } from '@angular/fire';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { HeaderComponent } from './modules/header/header.component';
import { GuardService } from './guard.service';
import { LocalSpinnerModule } from 'src/shared/components/local-spinner/local-spinner.module';
import { PopoverModule } from './modules/popover/popover.module';
import { UnitPriceComponent } from './modules/customize/preorder/unit-price/unit-price.component';
registerLocaleData(localeFr);
@NgModule({
  imports: [
    BrowserModule.withServerTransition({appId: 'favie-tech-angular'}),
    ReactiveFormsModule,
    TransferHttpCacheModule,
    TranslateBrowserModule,
    TranslateModule,
    FormsModule,
    AppRoutingModule,
    HttpClientModule,
    AngularFireStorageModule,
    LocalSpinnerModule,
    PopoverModule,
    AngularFireModule.initializeApp(environment.firebaseConfig, 'cloud'),
    // Enable service worker.
    ServiceWorkerModule.register('./ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerImmediately',
    }),

    BrowserAnimationsModule,
  ],
  declarations: [
    AppComponent,
    StepperComponent,
    ChooseClothesComponent,
    FooterComponent,
    HeaderComponent,
    PreorderComponent,
    UnitPriceComponent,
    ContactInfoComponent,
    SuccessComponent,
    FailureComponent,
  ],
  bootstrap: [AppComponent],
  providers: [
    GuardService,
    NgSwLogUpdateService,
    NgSwPromptUpdateService,
    NgSwCheckForUpdateService,
    { provide: STORAGE, useClass: BrowserStorage },
    { provide: LOCALE_ID, useValue: 'fr-FR' },
  ],
  exports: [
    UnitPriceComponent
  ]
})
export class AppModule {
  constructor(
    @Inject(PLATFORM_ID) platformId: object,
    @Inject(APP_ID) appId: string
  ) {
    const platform = isPlatformBrowser(platformId)
      ? 'in the browser'
      : 'on the server';
    console.log(`Running ${platform} with appId=${appId}`);
  }
}
